import React from 'react'

import NumericInput from '../Input/NumericInput'

interface IProps {
  clearable?: boolean
  disableFuture?: boolean
  disabled?: boolean
  error?: boolean
  float?: boolean
  label?: string
  locale?: string
  max?: number
  min?: number
  onChange: (value: number | undefined) => void
  value: number | undefined
}

const RangedInput = (props: IProps) => {
  const { value, onChange, label, min, max, error, disabled, float } = props
  const [forceRender, setRerender] = React.useState<boolean>(false)

  const onValueChange = (e: any) => {
    let val = float ? parseFloat(e) : parseInt(e, 10)
    if (max && val > max) {
      val = max
      setRerender(!forceRender)
    } else if (min && val < min) {
      val = min + 1
      setRerender(!forceRender)
    }
    onChange(val)
  }

  const pickerProps = {
    value,
    onChange: onValueChange,
    label,
    error,
    disabled,
  }

  return (
    <div style={{ width: '25%', display: 'inline-block' }}>
      <NumericInput inputType={'text'} {...pickerProps} bufferNeedUpdate={forceRender} />
    </div>
  )
}

export default RangedInput
